import { localStorageConstants } from "../constants/localStorageConstants";
import { deleteLocalStorage } from "./get-set-local-storage";

export const clearStoreAndLogout = () => {
  deleteLocalStorage(localStorageConstants.TOKEN);
  deleteLocalStorage(localStorageConstants.ORG_ID);
  deleteLocalStorage(localStorageConstants.USER);
};
